import { FormatNegativeNumber } from "../../../utils/format-negative-number";
import { FormatNumbers } from "../../../utils/format-numbers";
import { formatHours } from "../../../utils/format-hours";

/**
 * @class FormatUnits
 * Classe responsável em formatar as units a partir do parametro passado
 */
export class FormatUnits {
    constructor($filter) {
        this.$filter = $filter;
    }

    /**
     * @public
     * Format the value by the unit
     * @param {String} unit Unit to format
     * @param {Number} value Value unformatted
     * @return {Number} Value formatted
     */
    formatValue = (unit = "currency", value, fixedValue = 0, multiply) => {
        const numbersFormat = {
            number: () => this.$filter("number")(value, fixedValue),
            decimal: () => this.$filter("number")(value, fixedValue),
            day: () => this.$filter("number")(value, 0),
            int: () => this.$filter("number")(value, 0),
            hours: () => formatHours(value),
            currency: () => FormatNumbers.byUnit("currency", value, 2),
            currencyNumber: () =>
                this.formatCurrencyNumber({ value, fixedValue }),
            percentage: () =>
                multiply
                    ? `${this.$filter("formatPorcentagem")(
                          this._getFixedValue(value * 100, fixedValue)
                      )}%`
                    : `${this.$filter("formatPorcentagem")(
                          this._getFixedValue(value, fixedValue)
                      )}%`
        };
        if (numbersFormat[unit]) return numbersFormat[unit]();
    };

    formatCurrencyNumber({ value, fixedValue }) {
        const numberFormatted = this.$filter("number")(value, fixedValue);
        return FormatNegativeNumber({ number: value, numberFormatted });
    }

    /**
     * @private
     * Format the value by the fixed value
     * @param {Number} fixedValue Unit to format
     * @param {Number} value Value unformatted
     * @return {Number} Value formatted
     */
    _getFixedValue(value, fixedValue) {
        if (!value) return 0;
        const fixedFormatted = {
            0: value.toFixed(0),
            1: value.toFixed(1),
            2: value.toFixed(2)
        };

        return fixedFormatted[fixedValue];
    }
}
